export const COLLAPSED_HEIGHT = 34;
export const BUTTON_HEIGHT = 34;
export const EXPANDED_HEADER_HEIGHT = 48;
export const DEFAULT_CSS_HEIGHT = 'calc(100% - 2px)';
export const SCROLL_BAR_WIDTH = 10;

// Constants from Nebula (make sure to sync)
export const ITEM_MIN_WIDTH = 56;
export const ITEM_MAX_WIDTH = 150;
export const REMOVE_TICK_LIMIT = 80;
export const CHAR_WIDTH = 9; // to be more precise, this should be calculated based on font
export const FREQUENCY_ADD_WIDTH = 8 * CHAR_WIDTH;
export const CHECKBOX_ADD_WIDTH = 38;
export const TICK_WIDTH = 20;
export const COLUMN_MIN_WIDTH = 160;
export const COLUMN_SPACING = 16;
export const ITEM_SPACING = 8;
export const GRID_ROW_HEIGHT = 32;
export const LIST_ROW_HEIGHT = 29;
export const DENSE_ROW_HEIGHT = 20; // same for both list and grid in dense mode
